import { z } from "zod";

const UpdateBrandFeatureStatusSchema = z.object({
  brandId: z.number().int().positive(),
  featureId: z.number().int().positive(),
  isActive: z.boolean(),
});

export type UpdateBrandFeatureStatusDTOShape = z.infer<
  typeof UpdateBrandFeatureStatusSchema
>;

export class UpdateBrandFeatureStatusDTO {
  readonly brandId!: number;
  readonly featureId!: number;
  readonly isActive!: boolean;

  constructor(data: UpdateBrandFeatureStatusDTOShape) {
    const validated = UpdateBrandFeatureStatusSchema.parse(data);
    Object.assign(this, validated);
  }

  static validate(data: unknown) {
    return UpdateBrandFeatureStatusSchema.safeParse(data);
  }
}
